/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import { useEffect, useRef } from "react";

export function useTimerRef(): [
  (newTimer: NodeJS.Timeout) => void,
  () => void
] {
  const timer = useRef<NodeJS.Timeout>();

  const setTimer = (newTimer: NodeJS.Timeout | undefined) => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
    timer.current = newTimer;
  };

  const clearTimer = () => setTimer(undefined);

  return [setTimer, clearTimer];
}

export function useInterval(
  callback: () => void,
  interval: number,
  enabled = true
) {
  const timer = useRef<NodeJS.Timeout>();

  useEffect(() => {
    if (timer.current) {
      clearInterval(timer.current);
    }
    if (callback && enabled) {
      timer.current = setInterval(callback, interval);
    }
    return () => {
      if (timer.current) {
        clearInterval(timer.current);
      }
    };
  }, [callback, interval, enabled]);
}
